import React from "react";
import { CalendarClock, Phone, ArrowRight } from "lucide-react";

// Inline scheduling nudge banner — for use throughout the home page
export default function ScheduleNudge({ variant = "default", message }) {
  if (variant === "compact") {
    return (
      <div className="surface-sage rounded-2xl p-5 flex items-center justify-between gap-4 flex-wrap" data-testid="nudge-compact">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-full bg-[#0E6E5E] flex items-center justify-center text-white flex-shrink-0">
            <CalendarClock size={18} />
          </div>
          <div>
            <div className="font-semibold text-[#0A2520] text-sm">{message || "Not sure where to start?"}</div>
            <div className="text-xs text-[#5A6B66]">Free 30-min consultation · in your language</div>
          </div>
        </div>
        <button className="btn-accent text-sm" data-testid="nudge-compact-cta">Schedule a Free Call <ArrowRight size={14}/></button>
      </div>
    );
  }

  if (variant === "dark") {
    return (
      <div className="rounded-3xl p-8 lg:p-10 grid lg:grid-cols-[1.4fr_auto] gap-6 items-center surface-deep" data-testid="nudge-dark">
        <div>
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#7CC242] font-semibold mb-3">
            <CalendarClock size={12}/> Speak with an expert
          </div>
          <h3 className="font-display font-extrabold text-3xl lg:text-4xl mb-2 leading-tight">{message || "Bring your idea. Leave with a plan."}</h3>
          <p className="text-white/70 leading-relaxed max-w-xl">Book a no-obligation call with our senior IP counsel. We'll review your idea, surface eligibility risks, and recommend the next 3 steps.</p>
        </div>
        <div className="flex flex-col sm:flex-row lg:flex-col gap-3">
          <button className="btn-accent text-sm" data-testid="nudge-dark-cta">
            <CalendarClock size={14}/> Schedule a Free Call
          </button>
          <a href="tel:1800-UDHYAK-1" className="btn-outline text-sm bg-transparent border-white/30 text-white hover:bg-white hover:text-[#0A2520]">
            <Phone size={14}/> Call us now
          </a>
        </div>
      </div>
    );
  }

  // default banner
  return (
    <div className="card-flat p-7 lg:p-9 grid lg:grid-cols-[1fr_auto] gap-5 items-center border-[#0E6E5E]/20 bg-gradient-to-br from-[#EBF3EC] to-white" data-testid="nudge-default">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-2xl bg-[#0E6E5E] flex items-center justify-center text-white flex-shrink-0">
          <CalendarClock size={20}/>
        </div>
        <div>
          <div className="font-display font-bold text-2xl text-[#0A2520] mb-1">{message || "Talk to a senior IP expert — free."}</div>
          <p className="text-sm text-[#5A6B66] leading-relaxed">30-minute consultation in English, Hindi, Tamil, Telugu, Marathi, Bengali or Gujarati. No commitment, no credit card.</p>
        </div>
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <button className="btn-primary text-sm" data-testid="nudge-default-cta">Schedule Call <ArrowRight size={14}/></button>
      </div>
    </div>
  );
}
